import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ResetPasswordSubmission } from "admin-common";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { ClientService } from "src/app/Services/client.service";
import { StorageService } from "../../Services/storage.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-reset-password",
  standalone: false,
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
})
export class ResetPasswordComponent implements OnInit {
  /** Theme configuration for the library components */
  theme: ProjectTheme = "WUnivers";

  /** User's email address extracted from query parameters */
  email: string = "";

  /** Reset token extracted from route parameters */
  token: string = "";

  /**Snackbrar params*/
  snackbarText: string = "";
  showSnackbar: boolean = false;
  snackbarTheme: "warning" | "alert" | "success" | "information" = "success";

  constructor(
    private storage: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
    private translate: TranslateService,
  ) { }

  /**
   * Initializes the component
   * Extracts token from route parameters and email from query parameters
   */
  ngOnInit(): void {
    // Get token from route parameters
    this.token = this.route.snapshot.paramMap.get("token") || "";

    // Optional: get email from query parameters if available
    this.email = this.route.snapshot.queryParamMap.get("email") || "";
  }

  /**
   * Handles new password submission
   * Sends the new password and token to the server
   * @param submission The password reset submission containing the new password and token
   */
  handleNewPasswordSubmission(submission: ResetPasswordSubmission): void {
    this.clientService
      .resetPassword(submission.password, submission.token ?? "")
      .subscribe({
        next: () => {
          this.showSnackbar = true;
          this.snackbarTheme = "success";
          this.snackbarText = this.translate.instant(
            "session.resetPassword.success",
          );
          //store a property accountConfirmed (so we can hide the registration popup in the home page after confirmation)
          this.storage.setItem("openLoginDialogue", "true");
          //redirect to home after password reset
          setTimeout(() => {
            this.router.navigate(["/"]);
            this.showSnackbar = false;
          }, 2000);
        },
        error: (err) => {
          // Error handling
          this.showSnackbar = true;
          this.snackbarTheme = "alert";
          this.snackbarText = this.translate.instant(
            "session.resetPassword.invalidLink",
          );
          setTimeout(() => {
            this.showSnackbar = false;
          }, 3000);
          console.error("Reset failed:", err.status, err.message, err.error);
        },
      });
  }

  /**
   * Navigates back to the home page
   * Used when user cancels password reset or after successful reset
   */
  cancel(): void {
    this.router.navigate(["/"]);
  }
}
